enum Modules {
  devices = 'devices',
  idMapping = 'id-mapping',
  ipGeolocation = 'ip-geolocation',
  onNetOffNet = 'on-net-off-net',
  esnMapping = 'esn-mapping',
  alexaCapability = 'alexa-capability',
  anonymizer = 'anonymizer',
  bootstrap = 'bootstrap',
  rtf = 'rtf',
  npvr = 'npvr',
}

export default Modules
